<template>
	<div class="mx-auto max-w-sm md:max-w-lg lg:ml-0 lg:mr-0 lg:max-w-lg">
		<div
			ref="widget"
			class="trustpilot-widget"
			data-locale="en-US"
			data-template-id="5419b6ffb0d04a076446a9af"
			data-businessunit-id="5e1f84631d20eb000130bc73"
			data-style-height="20px"
			data-style-width="100%"
			data-theme="light"
		>
			<NuxtLink
				to="https://www.trustpilot.com/review/carclarity.com.au"
				target="_blank"
				rel="noopener"
			>
				&nbsp;
			</NuxtLink>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue'

const widget = ref(null)

onMounted(() => {
	if (import.meta.client) {
		// Check if the property exists on the window object and reinit
		pollFunctionUntilReady(() => window.Trustpilot, 200, 20).then(
			(trustPilot) => {
				if (trustPilot) {
					trustPilot.loadFromElement(widget.value, true)
				}
			}
		)
	}
})
</script>
